import { Component, OnInit, Input } from '@angular/core';
import { QuibblService } from '../../quibbl.service';

@Component({
  selector: 'quibbl-grid',
  templateUrl: './quibbl-grid.component.html',
  styleUrls: ['./quibbl-grid.component.scss']
})
export class QuibblGridComponent implements OnInit {

  @Input() category: string;

  public politics;
  public politicsSubscription;

  public entertainment;
  public entertainmentSubscription;

  public sports;
  public sportsSubscription;

  public reachedEnd = {};
  public isFetching;
  public loadLimit = 4;

  constructor(private _qb: QuibblService) { }

  ngOnInit() {
    this.resubscribe();
  }

  ngOnDestroy() {
    if(this.politicsSubscription) this.politicsSubscription.unsubscribe();
    if(this.entertainmentSubscription) this.entertainmentSubscription.unsubscribe();
    if(this.sportsSubscription) this.sportsSubscription.unsubscribe();
  }

  ngOnChanges() {
    if(this.politicsSubscription) this.politicsSubscription.unsubscribe();
    if(this.entertainmentSubscription) this.entertainmentSubscription.unsubscribe();
    if(this.sportsSubscription) this.sportsSubscription.unsubscribe();
    this.resubscribe();
  }

  resubscribe() {
    this.politicsSubscription =
      this._qb.getQuibbls('politics', this.loadLimit).subscribe(quibbls => {
        this.politics = [];
        for(let i=quibbls.length-1; i>=0; i--) {
          this.politics.push(quibbls[i]);
        }
      });
    this.entertainmentSubscription =
      this._qb.getQuibbls('entertainment', this.loadLimit).subscribe(quibbls => {
        this.entertainment = [];
        for(let i=quibbls.length-1; i>=0; i--) {
          this.entertainment.push(quibbls[i]);
        }
      });
    this.sportsSubscription =
      this._qb.getQuibbls('sports', this.loadLimit).subscribe(quibbls => {
        this.sports = [];
        for(let i=quibbls.length-1; i>=0; i--) {
          this.sports.push(quibbls[i]);
        }
      });
  }

  public fetchMoreQuibbls() {
    if(this.isFetching) {
      return;
    }

    this.isFetching = true;
    let fetchingSports = true;
    let fetchingPolitics = true;
    let fetchingEntertainment = true;

    // SPORTS
    if(!this.reachedEnd['sports']) {
      if(this.sportsSubscription) this.sportsSubscription.unsubscribe();
      let newLimit = this.sports.length + this.loadLimit;
      this.sportsSubscription =
        this._qb.getQuibbls('sports', newLimit).subscribe(quibbls => {
          let diff = quibbls.length - this.sports.length;
          if(quibbls.length < newLimit) {
            this.reachedEnd['sports'] = true;
          }
          for(let i=diff-1; i>=0; i--) {
            if(quibbls[i]) {
              this.sports.push(quibbls[i]);
            }
            else {
              this.reachedEnd['sports'] = true;
              break;
            }
          }
          fetchingSports = false;
          if(!fetchingSports && !fetchingPolitics && !fetchingEntertainment) {
            this.isFetching = false;
          }
        });
    } else {
      fetchingSports = false;
    }

    // POLITICS
    if(!this.reachedEnd['politics']) {
      if(this.politicsSubscription) this.politicsSubscription.unsubscribe();
      let newLimit = this.politics.length + this.loadLimit;
      this.politicsSubscription =
        this._qb.getQuibbls('politics', newLimit).subscribe(quibbls => {
          let diff = quibbls.length - this.politics.length;
          if(quibbls.length < newLimit) {
            this.reachedEnd['politics'] = true;
          }
          for(let i=diff-1; i>=0; i--) {
            if(quibbls[i]) {
              this.politics.push(quibbls[i]);
            }
            else {
              this.reachedEnd['politics'] = true;
              break;
            }
          }
          fetchingPolitics = false;
          if(!fetchingSports && !fetchingPolitics && !fetchingEntertainment) {
            this.isFetching = false;
          }
        });
    } else {
      fetchingPolitics = false;
    }

    // POLITICS
    if(!this.reachedEnd['entertainment']) {
      if(this.entertainmentSubscription) this.entertainmentSubscription.unsubscribe();
      let newLimit = this.entertainment.length + this.loadLimit;
      this.entertainmentSubscription =
        this._qb.getQuibbls('entertainment', newLimit).subscribe(quibbls => {
          let diff = quibbls.length - this.entertainment.length;
          if(quibbls.length < newLimit) {
            this.reachedEnd['entertainment'] = true;
          }
          for(let i=diff-1; i>=0; i--) {
            if(quibbls[i]) {
              this.entertainment.push(quibbls[i]);
            }
            else {
              this.reachedEnd['entertainment'] = true;
              break;
            }
          }
          fetchingEntertainment = false;
          if(!fetchingSports && !fetchingPolitics && !fetchingEntertainment) {
            this.isFetching = false;
          }
        });
    } else {
      fetchingEntertainment = false;
    }


  }

}



// WEBPACK FOOTER //
// /Users/nicholasgerard/Documents/Quibbl/quibbl/src/app/common/quibbl-grid/quibbl-grid.component.ts